var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "el-drawer",
        {
          attrs: {
            title: _vm.title,
            visible: _vm.drawer,
            size: "600px",
            wrapperClosable: false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.drawer = $event
            },
          },
        },
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              staticClass: "form-center",
            },
            [
              _c(
                "el-form",
                {
                  ref: "form",
                  attrs: {
                    model: _vm.form,
                    "label-width": "100px",
                    rules: _vm.rules,
                  },
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "库区编号", prop: "Code" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请输入库区编号" },
                        model: {
                          value: _vm.form.Code,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "Code", $$v)
                          },
                          expression: "form.Code",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "库区名称", prop: "Name" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请输入库区名称" },
                        model: {
                          value: _vm.form.Name,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "Name", $$v)
                          },
                          expression: "form.Name",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "货区类型" } },
                    [
                      _c("SelectDicValue", {
                        ref: "SelectDicValue",
                        attrs: { code: "StorAreaType" },
                        model: {
                          value: _vm.form.Type,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "Type", $$v)
                          },
                          expression: "form.Type",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              staticClass: "footer",
            },
            [
              _c("el-button", { on: { click: _vm.close } }, [_vm._v("取消")]),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.handleSubmit } },
                [_vm._v("保存")]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }